export const DOB_MODAL_EVENT_ENTITY_TYPE = {
  DOB_MODAL_OPENED: 'dob_modal_opened',
  DOB_ADDED: 'dob_added',
  DOB_REMOVED: 'dob_removed',
  DOB_ADDED_ERROR: 'dob_added_error',
}
